export const GET_BIRTHDAY_INFO = "GET_BIRTHDAY_INFO";
export const SET_BIRTHDAY_INFO = "SET_BIRTHDAY_INFO";

export const getBirthdayInfo = () => {
  return {
    type: GET_BIRTHDAY_INFO,
  };
};
export const setBirthdayInfo = (data) => {
  return {
    type: SET_BIRTHDAY_INFO,
    data,
  };
};

export const GET_NEW_COLABORATORS_INFO = "GET_NEW_COLABORATORS_INFO";
export const SET_NEW_COLABORATORS_INFO = "SET_NEW_COLABORATORS_INFO";

export const getNewColaboratorsInfo = () => {
  return {
    type: GET_NEW_COLABORATORS_INFO,
  };
};

export const setNewColaboratorsInfo = (data) => {
  return {
    type: SET_NEW_COLABORATORS_INFO,
    data,
  };
};

export const GET_PROFILE_DATA = "GET_PROFILE_DATA";
export const SET_PROFILE_DATA = "SET_PROFILE_DATA";
export const UPDATE_PROFILE_DATA = "UPDATE_PROFILE_DATA";
export const SET_UPDATE_PROFILE_DATA = "SET_UPDATE_PROFILE_DATA";

export const getProfileData = (funcNum, codEmp) => {
  return {
    type: GET_PROFILE_DATA,
    funcNum,
    codEmp,
  };
};
export const setProfileData = (data) => {
  return {
    type: SET_PROFILE_DATA,
    data,
  };
};

export const updateProfileData = (payload) => {
  return {
    type: UPDATE_PROFILE_DATA,
    payload,
  };
};
export const setUpdateProfileData = (data) => {
  return {
    type: SET_UPDATE_PROFILE_DATA,
    data,
  };
};
